import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class FirestoreService {

    constructor(public firestore: AngularFirestore) {}

    getBlog(id: string) {
        return this.firestore.doc(`news/${id}`);
    }

    getBlogList(limit: number) {
        return this.firestore.collection(`news`, ref => ref.where('published', '==', 'true').orderBy('date', 'asc').limit(limit));
    }

    query(document, query) {
        return this.firestore.collection(document, query);
    }

    getCollection(collection: string) {
        return this.firestore.collection(collection, ref => ref.where('show', '==', 'true'));
    }

    getData(collection: string, lang: string) {
        return this.firestore.collection(collection, ref => ref.where('lang', '==', lang));
    }

    getDataFiltered(collection: string, lang: string, type: string) {
        return this.firestore.collection(collection, ref => ref.where('lang', '==', lang).where('type', '==', type ));
    }

    getMenu(collection: string, lang: string) {
        return this.firestore.collection(collection).doc(lang);
    }

    getMenuFiltered(collection: string, lang: string, filter: string) {
        return this.firestore.collection(collection).doc(lang);
    }

    getAllBrands() {
        return this.firestore.collection('brands');
    }

    getCollectionFiltered(collection: string, category: string) {
        const hoy = moment().valueOf();
        return this.firestore
            .collection(collection, ref =>
                ref.where('dateFrom', '<', hoy)
                    .where('category', '==', category)
                    .where('show', '==', 'true')
                  .where('highlight', '==', 'false')
                  .orderBy('dateFrom', 'asc')
                    .orderBy('order', 'asc'));
    }

    getCollectionFilteredHighlight(collection: string, category: string) {
        const hoy = moment().valueOf();
        return this.firestore
            .collection(collection, ref =>
                ref.where('dateFrom', '<', hoy)
                    .where('category', '==', category)
                    .where('show', '==', 'true')
                    .where('highlight', '==', 'true')
                    .orderBy('dateFrom', 'asc')
                    .orderBy('order', 'asc'));
    }

    getAccesoriesFiltered(collection: string, field: string, filter: string) {
        return this.firestore
            .collection(collection, ref =>
                ref.where(field, '==', filter)
                    .where('show', '==', 'true')
                    .orderBy('order', 'asc'));
    }

    getAccessories() {
        const hoy = moment().valueOf();
        return this.firestore
            .collection('accessories', ref =>
                ref.where('dateFrom', '<', hoy)
                    .where('show', '==', 'true')
                    .where('highlight', '==', 'false')
                    .orderBy('dateFrom', 'asc'));
    }

    getAccessoriesHighlight() {
        const hoy = moment().valueOf();
        return this.firestore
            .collection('accessories', ref =>
                ref.where('dateFrom', '<', hoy)
                    .where('show', '==', 'true')
                    .where('highlight', '==', 'true')
                    .orderBy('dateFrom', 'asc'));
    }

    getBoutique() {
        return this.firestore
            .collection('accessories', ref =>
                ref.where('category', '==', 'boutique')
                    .where('show', '==', 'true')
                    .orderBy('order', 'asc'));
    }

    getCollectionFilteredBy(collection: string, category: string, type: string) {
        return this.firestore.collection(collection, ref => ref.where(type, '==', category).where('show', '==', 'true'));
    }

    sendContact(
        name: string,
        email: string,
        lang: string,
        message: string,
        timestamp: any,
    ): Promise<void> {
        const id = this.firestore.createId();
        return this.firestore.doc(`contactMessages/${id}`).set({
            id,
            name,
            email,
            lang,
            message,
            timestamp
        });
    }

}
